import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

import { getSourceDomainFromHost } from './get-source-domain-from-host';

export const getSourceDomainFromClient = () => {
  if (typeof globalThis.window === 'undefined') return SourceDomain.PflegiaDe;
  const { host } = globalThis.window.location;
  return getSourceDomainFromHost(host);
};
